import * as React from 'react';

export function useId(idProp?: string) {
  const [defaultId, setDefaultId] = React.useState(idProp);
  const id = idProp || defaultId;

  React.useEffect(() => {
    if (defaultId == null) {
      setDefaultId(`doxyme-${Math.round(Math.random() * 1e5)}`);
    }
  }, [defaultId]);

  return id;
}
